<template>
  <div class="order-card-wrapper">
    <div class="header-box">
      <p
        class="order-status-desc"
        :class="{'high-light': highlight(orderInfo.status)}"
        v-text="orderInfo.statusDesc"
      ></p>
      <p class="order-alert-msg" v-text="orderInfo.alertMsg"></p>
      <p class="order-create-time" v-text="orderInfo.createTime"></p>
    </div>
    <div class="shop-detail-wrapper">
      <div class="logo-img" :class="{'has-logo': shopInfo.logoImg}">
        <img
          v-if="shopInfo.logoImg"
          v-lazy="shopInfo.logoImg"
        />
        <ShopStatus
          size="small"
          :status="+shopInfo.cShopStatus"
          :next-time="shopInfo.nextBizTimeDesc"
        />
      </div>
      <div class="shop-info-box">
        <!-- 门店详情入口 门店名最多两行 -->
        <div class="shop-detail-btn">
          <p class="shop-name" @click="goShopDetail">{{shopInfo.shopName}}</p>
          <i class="icon-outline_entrance" @click="goShopDetail"></i>
        </div>
        <!-- 门店活动标签 | 非营业状态信息 无不展示但占位 -->
        <div class="tag-box">
          <template v-if="businessStatusMap.noBusiness">
            <p class="status-tag" v-text="businessStatusMap.statusDesc"></p>
            <p class="time-desc" v-text="businessStatusMap.timeDesc"></p>
          </template>
          <template v-else>
            <ShopTag
              v-for="(item, index) in shopInfo.actTips"
              :key="'tag' + index"
              :text="item"
            />
          </template>
        </div>
        <!-- 第一个菜的名称 规格（可有可无） -->
        <div class="cate-wrapper">
          <p class="cate-name" :class="{'no-options': !itemMap.subItemDesc}" v-text="itemMap.itemName"></p>
          <p class="cate-options" v-text="itemMap.subItemDesc"></p>
        </div>
        <!-- view all | 查看订单详情 -->
        <p class="detail-btn" @click="showOrderDetail">
          <span class="content">{{viewText}}</span>
          <i class="icon-outline_entrance"></i>
        </p>
      </div>
      <div class="right-box">
        <template
          v-for="(buttonMap, index) in buttons"
        >
          <!-- 不展示评价 | 展示评价 | 付款按钮 | 评价按钮 | 查看订单详情 -->
          <div
            class="rate-box"
            v-if="(buttonMap.type === 3 || buttonMap.type === 4) && evaluation"
            :key="'button' + index"
          >
            <div
              class="rate-star"
              :class="{'good': +evaluation.score >= 500}"
              @mouseleave="starZero(buttonMap.type)"
            >
              <i
                class="rate-star-icon"
                v-for="(iratecon, iconIndex) in starList"
                :key="'icon' + iconIndex"
                :class="iconIndex + 1 > evaluation.score/100 ? 'icon-outline_star_rating' : 'icon-filled_star cur'"
                @mouseover="starHover(buttonMap.type, iconIndex)"
                @click="btnClick(buttonMap.type, {score: (iconIndex + 1) * 100})"
              ></i>
            </div>
            <p class="rate-star-desc" :class="{'good': +evaluation.score >= 500}" v-text="evaluation.desc"></p>
          </div>
          <el-button
            v-else
            :key="'button' + index"
            class="order-btn"
            :dark="!buttonMap.highlight"
            outline
            v-text="buttonMap.name"
            @click="btnClick(buttonMap.type)"
          ></el-button>
        </template>
      </div>
      <p class="order-price" v-text="orderInfo.realPayPriceDisplay"></p>
    </div>
    <!-- 代购代购订单/进店和详情都不支持 列表被后端过滤 -->
  </div>
</template>

<script>
import mixin from './mixin.js'
import ShopStatus from '@/components/ShopTopInfo/shopStatus.vue'
import ShopTag from '@/components/ShopCard/tag.vue'

export default {
  name: 'OrderCard',
  components: {
    ShopStatus,
    ShopTag,
  },
  props: {
    info: Object,
  },
  mixins: [mixin],
  data() {
    return {
      shopInfo: {},
      orderInfo: {},
      evaluation: null,
      itemMap: {},
      buttons: [],
      starList: [{}, {}, {}, {}, {}],
      businessStatusMap: {
        noBusiness: false,
        timeDesc: '',
        statusDesc: '',
      }
    }
  },
  computed: {
    viewText() {
      let text = ''
      let n = this.info?.itemInfo?.items?.length
      if (n > 1) {
        text = this.$t('查看更多') + '('+ n +')'
      } else {
        text = this.$t('查看订单详情')
      }
      return text 
    }
  },
  created() {
    this.init(this.info)
    this.computedBusinessStatus(+this.shopInfo.cShopStatus, this.shopInfo.nextBizTimeDesc)
  },
  methods: {
    init(nVal) {
      this.shopInfo = nVal?.shopInfo
      this.orderInfo = nVal?.orderInfo
      this.itemMap = nVal?.itemInfo?.items[0]
      this.buttons = nVal?.buttons.filter(item => +item.type !== 2) || []
      nVal?.evaluation && this.initEvaluation(nVal?.evaluation)
    },
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>